var reflect = function reflect(f) {
  return function (x) {
    return -f(-x);
  };
};
export var logs = function logs(base, shouldReflect) {
  var baseCache = Math.log(base);
  var log = base === Math.E ? Math.log : base === 10 ? Math.log10 : base === 2 ? Math.log2 : function (x) {
    return Math.log(x) / baseCache;
  };
  return shouldReflect ? reflect(log) : log;
};
export var pows = function pows(base, shouldReflect) {
  var pow = base === Math.E ? Math.exp : function (x) {
    return Math.pow(base, x);
  };
  return shouldReflect ? reflect(pow) : pow;
};